(function () {
    var androidPackage = 'com.landportal.app'; // из assetlinks.json
    var scheme = 'landportal';                 // custom scheme

    const urlParams = new URLSearchParams(window.location.search);
    let property = urlParams.get('property');
    if (property) {
        // Запускаем сразу
        openApp(property);
    }

    function isAndroid() {
        return /Android/i.test(navigator.userAgent);
    }

    function openApp(property) {

        if (isAndroid()) {
            var intentUrl =
                'intent://?' + 'property=' + encodeURIComponent(property) +
                '#Intent;scheme=' + scheme +
                ';package=' + androidPackage +
                ';end';

            window.location = intentUrl;
        }
    }


})();